import request from '@/libs/request';

export const ContractList = (data = {}) => request('ContractList', data); // 查询列表数据
export const ContractEdit = (data = {}) => request('ContractEditStatus', data); // 停用，退回；启用，通过，拒绝
